// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"55669fee","129":"e0922e6c","216":"11c4e45d","829":"11c4e45d","938":"c3f84aef"}[chunkId] + ".css";
};